import * as React from 'react';

import TablePagination from '@material-ui/core/TablePagination';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import { Error } from 'components/error/Error';
import { Loader } from 'components/loader/Loader';
import { STATUSES } from 'core/api';
import { IReduxStoreState } from 'core/store/interfaces';
import Article from 'pages/content/components/Article/Article';
import { IArticle } from 'pages/content/interfaces';

import { IArticlesData, IProps } from './interfaces';
import { doSearch } from './redux';

import styles from './SearchResults.module.styl';
import { extendQueryString } from '../content/helpers';

const MIN_PAGINATION_LIMIT = 10;

class SearchResults extends React.Component<IProps> {
  public componentDidMount(): void {
    const {
      location: { search, hash },
      match,
    } = this.props;

    this.props.doSearch({
      hash,
      locale: match.params.locale,
      search,
    });
  }

  public componentDidUpdate(prevProps: Readonly<IProps>): void {
    const {
      location: { search, hash },
      match,
    } = this.props;

    if (
      search !== prevProps.location.search ||
      hash !== prevProps.location.hash ||
      match.params.locale !== prevProps.match.params.locale
    ) {
      this.props.doSearch({
        hash,
        locale: match.params.locale,
        search,
      });
    }
  }

  public render() {
    return (
      <div className={styles.root}>
        <div className={styles.header}>Search results</div>
        <div className={styles.content}>{this.getSearchResults()}</div>
      </div>
    );
  }

  private getSearchResults = () => {
    const { searchResults } = this.props;

    switch (searchResults.status) {
      case STATUSES.INITIAL:
      case STATUSES.REQUEST:
        return <Loader />;
      case STATUSES.FAILED:
        return <Error>{searchResults.error}</Error>;
      case STATUSES.SUCCESS:
        const { articles, pagination } = searchResults.data.data;

        if (articles.length === 0) {
          return <Error>Nothing found</Error>;
        }

        return (
          <>
            {articles.map((article: IArticle) => (
              <div key={article.id} className={styles.wrapper}>
                <Article data={{ article }} preview={true} />
              </div>
            ))}
            {pagination && pagination.total > MIN_PAGINATION_LIMIT && (
              <TablePagination
                component="div"
                count={pagination.total}
                rowsPerPage={pagination.limit}
                page={pagination.page - 1}
                backIconButtonProps={{
                  'aria-label': 'Previous Page',
                }}
                nextIconButtonProps={{
                  'aria-label': 'Next Page',
                }}
                onChangePage={this.handleChangePage}
                onChangeRowsPerPage={this.handleChangeRowsPerPage}
              />
            )}
          </>
        );
      default:
        return null;
    }
  };

  private readonly handleChangePage = (
    event: React.MouseEvent<HTMLButtonElement, MouseEvent> | null,
    newPage: number,
  ) => {
    const { searchResults, location, history } = this.props;
    const { pagination } = searchResults.data.data as IArticlesData;

    history.push(
      `${location.pathname}${extendQueryString(location.search, {
        limit: pagination.limit,
        page: newPage + 1,
      })}${location.hash}`,
    );
  };

  private readonly handleChangeRowsPerPage = (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
  ) => {
    const { location, history } = this.props;

    history.push(
      `${location.pathname}${extendQueryString(location.search, {
        limit: event.target.value,
        page: 1,
      })}${location.hash}`,
    );
  };
}

const mapState = (state: IReduxStoreState) => ({
  searchResults: state.searchResults,
});

const mapDispatch = {
  doSearch,
};

export default connect(mapState, mapDispatch)(withRouter(SearchResults));
